import { CalendarOutlined } from "@ant-design/icons";
import { CoinIcon } from "@components";
import { selectAuth, selectMerchant } from "@redux";
import { formatMessage, useNotify } from "@utils";
import { Avatar, Button, Tabs } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { eComClaimPointAPI } from "../../API/ecomClaimpoint";

import { format } from "date-fns";
import { useFullScreen } from "src/Helpers/useFullscreen";
import styled from "styled-components";
import { IconCheck2 } from "../icon/Check2";
import { IconPoint } from "../icon/IconPoint";
import { IconStroke } from "../icon/IconStroke";
import { IconLink } from "../icon/Link";
import { BackIcon } from "../icon/TopSpender/BackIcon";

const { TabPane } = Tabs;

export const ComponentLinkBuying = () => {
    const { success, error, warning } = useNotify();
    const history = useHistory();
    const [tab, setTab] = useState<string>("1");
    const [isShowPopup, setShowPopup] = useState<boolean>(false);
    const [dataList, setDataList] = useState<any>([]);
    const [showConfirm, setShowConfirm] = useState(false);
    const [point, setPoint] = useState<any>(0);

    const { themes } = useSelector(selectMerchant);
    const merchant = useSelector(selectMerchant);
    const { userInfo } = useSelector(selectAuth);
    const fullHeight = useFullScreen();
    const type = "SHOPEE";

    function callback(items: any) {
        setTab(items);
    }

    const getList = async () => {
        try {
            const res = await eComClaimPointAPI.getList("?storeType=" + type);
            // console.log("res =>", res.data);
            setDataList(res.data);
        } catch (err: any) {
            error(formatMessage(err.response));
        }
    };

    useEffect(() => {
        getList();
    }, []);

    const sendOrder = async (orderId: string, channel: string) => {
        try {
            const res = await eComClaimPointAPI.claimPoint({
                orderId: orderId,
                storeType: channel,
            });
            if (res.data) {
                setShowConfirm(true);
                setPoint(res.data?.point);
                getList();
            }
        } catch (err: any) {
            error(formatMessage(err.response));
        }
    };

    return (
        <StyledContainer color={themes?.themeColor!} type={type} style={{ height: fullHeight }}>
            <div className="container">
                <br />
                <div className="backIcon" onClick={() => history.goBack()}>
                    <BackIcon color={"#FFF"} />
                    <h2>Link Account Buying</h2>
                    <p> </p>
                </div>
                <div className="header-content">
                    <div className="layout-profile">
                        <div style={{ display: "flex" }}>
                            <div className="avatar-profile">
                                <Avatar
                                    className="circle-avatar-user"
                                    shape="circle"
                                    alt="Avatar"
                                    src={userInfo?.avatar || "../images/img-profile-default-01.png"}
                                />
                            </div>
                            <div>
                                <div className="profile-name">
                                    {merchant?.advanceSettings?.tier?.isFullName
                                        ? userInfo?.contact?.fullName
                                        : userInfo?.contact?.firstName +
                                        " " +
                                        userInfo?.contact?.lastName}{" "}
                                    <span>
                                        <IconCheck2 />
                                    </span>
                                </div>
                                <div className="profile-id">
                                    Shoppee ID :{" "}
                                    {dataList?.orderPending?.length &&
                                        dataList?.orderPending[0]?.shopId
                                        ? dataList?.orderPending[0]?.shopId
                                        : ""}
                                </div>
                            </div>
                        </div>
                        <div className="point">
                            <CoinIcon size="17" /> {userInfo?.totalPoints}
                        </div>
                    </div>
                    <div className="divider"></div>
                    <div className="layout-profile">
                        <div className="sync-text">
                            Sync platform by :{" "}
                            <span className="platform-text">
                                {" "}
                                {type === "SHOPEE" ? "Shopee" : type}
                            </span>
                            <span>
                                <img
                                    src={
                                        type === "SHOPEE"
                                            ? "../images/shopee.png"
                                            : "../images/tiktok.png"
                                    }
                                />
                            </span>
                        </div>
                        <div className="re-text">
                            <span>
                                <IconLink />
                            </span>
                            Re-enter account
                        </div>
                    </div>
                </div>
                <div className="content">
                    <Tabs defaultActiveKey="1" activeKey={tab} onChange={callback}>
                        <TabPane
                            tab={
                                <span
                                    style={{
                                        color: tab === "1" ? themes?.themeColor : "#9B9B9B",
                                        fontSize: "13px",
                                    }}
                                >
                                    Pending Claim
                                </span>
                            }
                            key="1"
                        >
                            <div className="layout-slide-content">
                                {dataList?.orderPending?.map((item: any, inx: number) => (
                                    <div className="listColumn" key={inx}>
                                        <div className="content-list-column">
                                            <div className="text-top">
                                                <CalendarOutlined />{" "}
                                                {format(item.orderCreated, "DD MMM YYYY")} <div />{" "}
                                                <div className="divider-horizontal"></div>
                                                <div>
                                                    <IconStroke />
                                                </div>
                                                <CoinIcon size="17" />
                                                <div className="text-point">
                                                    {" "}
                                                    + {item.pointToGet || 0}{" "}
                                                </div>
                                            </div>
                                            <div>Order #{item.orderId}</div>
                                            {/* <div>EXP Claim : 12 Feb 2024</div> */}
                                        </div>
                                        <div>
                                            <Button
                                                className="btn-claim"
                                                onClick={() =>
                                                    sendOrder(item.orderId, item.storeType)
                                                }
                                            >
                                                Claim
                                            </Button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </TabPane>
                        <TabPane
                            tab={
                                <span
                                    style={{
                                        color: tab === "2" ? themes?.themeColor : "#9B9B9B",
                                        fontSize: "13px",
                                    }}
                                >
                                    Claimed
                                </span>
                            }
                            key="2"
                        >
                            <div className="layout-slide-content">
                                {dataList?.orderClaimed?.map((item: any, inx: number) => (
                                    <div className="listColumn">
                                        <div className="content-list-column">
                                            <div>Order #{item.orderId}</div>
                                            <div className="text-top">
                                                <CalendarOutlined />{" "}
                                                {format(item.orderCreated, "DD MMM YYYY")} <div />
                                            </div>
                                        </div>
                                        <div>
                                            <div className="text-point">
                                                <span>
                                                    <CoinIcon size="17" />
                                                </span>{" "}
                                                + {item.pointReceive}{" "}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </TabPane>
                        <TabPane
                            tab={
                                <span
                                    style={{
                                        color: tab === "3" ? themes?.themeColor : "#9B9B9B",
                                        fontSize: "13px",
                                    }}
                                >
                                    Expired
                                </span>
                            }
                            key="3"
                        >
                            <div className="layout-slide-content">
                                {dataList?.orderCancel?.map((item: any, inx: number) => (
                                    <div className="listColumn">
                                        <div className="content-list-column">
                                            <div className="text-top">
                                                <CalendarOutlined />{" "}
                                                {format(item.orderCreated, "DD MMM YYYY")} <div />{" "}
                                                <div className="divider-horizontal"></div>
                                                <CoinIcon size="17" />
                                                <div className="text-point">
                                                    + {item.pointReceive}{" "}
                                                </div>
                                            </div>
                                            <div>Order #{item.orderId}</div>
                                            {/* <div>EXP Claim : 12 Feb 2024</div> */}
                                        </div>
                                        <div>
                                            <Button className="btn-claim-disabled" disabled>
                                                Claim
                                            </Button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </TabPane>
                    </Tabs>
                </div>
            </div>
            {showConfirm ? (
                <StyledPopupRedeem>
                    <div className="box-popupconfirm">
                        <div className="img-popupconfirm">
                            <img src="../images/img-gift.svg" alt="" />
                        </div>
                        <div className="text-order">Order number founded</div>
                        <div className="title">
                            <div className="text-sub-header">Congrats!</div>
                            <div className="text-sub-header">
                                You Get{" "}
                                <span>
                                    <IconPoint size="20" />
                                </span>{" "}
                                {point} Points
                            </div>
                        </div>
                        <div className="btn-popupconfirm">
                            <StyledUsedBtn
                                className="btn-cancel"
                                themeColor={themes?.themeColor!}
                                onClick={() => {
                                    setShowConfirm(false);
                                }}
                            >
                                Cancel
                            </StyledUsedBtn>
                            <StyledBtnConfirm
                                themeColor={themes?.themeColor!}
                                className="check-order"
                                onClick={() => {
                                    setShowConfirm(false);
                                }}
                            >
                                Confirm
                            </StyledBtnConfirm>
                        </div>
                    </div>
                </StyledPopupRedeem>
            ) : null}
        </StyledContainer>
    );
};
const StyledContainer = styled.div<{ color: string; type: string }>`
    background-color: ${(p) => p.color};
    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
        color: #ff0000 !important;
        font-weight: 500;
    }
    .ant-tabs-nav-wrap {
        .ant-tabs-ink-bar {
            position: absolute;
            background: ${(p) => p.color};
            pointer-events: none;
            width: 20px !important;
            height: 3px;
            bottom: 0px;
            left: 37px;
            border-radius: 4px;
        }
    }
    .ant-tabs-content {
        margin-top: 10px;
    }

    .container {
        padding: 9px 16px 0px 16px;
        .backIcon {
            display: flex;
            // position: absolute;
            // top: 20px;
            // left: 20px;
            cursor: pointer;
            // z-index: 1;
            align-items: center;
            justify-content: space-between;
            // width: 80%;
            margin-bottom: 20px;
        }
        .header-content {
            display: flex;
            padding: 14px 12px 10px 12px;
            flex-direction: column;
            align-items: flex-start;
            gap: 10px;
            border-radius: var(--12-px, 12px);
            background: ${(p) =>
        p.type === "SHOPEE"
            ? "linear-gradient(180deg, rgba(242, 91, 44, 0.76) 0%, rgba(237, 56, 0, 0.9) 100%), var(--Background, #fff)"
            : "linear-gradient(0deg, #000 0%, rgba(0, 0, 0, 0.84) 100%)"};

            backdrop-filter: blur(2px);
            .layout-profile {
                display: flex;
                // align-items: center;
                width: 100%;
                justify-content: space-between;
                .avatar-profile {
                    width: 40px;
                    height: 40px;
                    border-radius: 100%;
                    margin-right: 10px;
                    .ant-avatar {
                        border-radius: 100%;
                        width: 40px;
                        height: 40px;
                        border: 1px solid ${(p) => p.color};
                    }
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
                .profile-name {
                    color: #fff;
                    font-size: 16px;
                    font-weight: 600;
                    line-height: 19px;
                }
                .profile-id {
                    color: #fff;
                    font-size: 11px;
                    font-weight: 400;
                    line-height: 14px;
                }
                .point {
                    color: #fff;
                    font-size: 14px;
                    font-weight: 600;
                    line-height: 17px;
                }
            }
            .divider {
                width: 100%;
                border: 0.5px dashed #e1e1e1;
            }
            .sync-text {
                display: flex;
                align-items: center;
                color: #fff;
                font-size: 11px;
                font-weight: 400;
                line-height: 14px;
            }
            .platform-text {
                color: #fff;
                font-size: 12px;
                font-weight: 500;
                line-height: 15px;
                margin-right: 10px;
            }
            .re-text {
                color: #fff;
                text-align: center;
                font-size: 10px;
                font-weight: 400;
                line-height: 13px;
                text-decoration-line: underline;
            }
        }
        h2 {
            color: #fff;
            font-size: 18px;
            font-weight: 600;
            line-height: 21px;
        }
        .ant-divider {
            background: #e1e1e1;
            width: 90%;
            min-width: 90%;
            margin: auto;
            margin: 22px auto 16px auto;
        }
    }
    .content {
        width: 100%;
        height: 75dvh;
        background-color: rgba(246, 246, 246, 1);
        // background-color: #fff;
        position: absolute;
        left: 0;
        bottom: 0;
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
        overflow: hidden;
        padding: 9px 16px 0px 16px;
        @media (max-width: 400px) {
            height: 65dvh;
        }
        .ant-tabs-nav {
            .ant-tabs-tab {
                padding: 0;
                margin: 0px 10px 10px 0px !important;
                width: 95px;
                height: 35px;
                span {
                    font-size: 16px;
                    font-weight: 600;
                }
            }
        }

        h1 {
            color: #000;
            font-size: 18px;
            line-height: 21px;
            font-weight: 600;
            margin-bottom: 10px;
        }
        .layout-slide-content {
            height: 60dvh;
            overflow: scroll;
            @media (max-width: 400px) {
                height: 50dvh;
            }
        }
        .listColumn {
            display: flex;
            padding: 12px;
            align-items: center;
            gap: 12px;
            align-self: stretch;
            border-radius: 14px;
            background: #fff;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 10px;
            .content-list-column {
                display: flex;
                flex-direction: column;
                gap: 3px;
            }
            .text-top {
                display: flex;
                align-items: center;
                color: #000;
                font-size: 14px;
                font-weight: 600;
                gap: 3px;
                span {
                    margin-right: 5px;
                }
                .divider-horizontal {
                    width: 0px;
                    height: 13px;
                    stroke-width: 1px;
                    stroke: #e1e1e1;
                }
            }

            .text-point {
                color: #26c2a4;
                font-size: 14px;
                font-weight: 600;
                line-height: 17px;
            }
            .text-desc {
                color: #9b9b9b;
                font-size: 11px;
                font-weight: 400;
                line-height: 14px;
            }
            .btn-claim {
                display: flex;
                padding: 6px 13px;
                justify-content: center;
                align-items: center;
                gap: 8px;
                border-radius: 9px;
                background: ${(props) => props.color};
                color: #fff;
                text-align: center;
                font-size: 12px;
                font-weight: 500;
                line-height: 15px;
            }
            .btn-claim-disabled {
                display: flex;
                padding: 6px 13px;
                justify-content: center;
                align-items: center;
                gap: 8px;
                border-radius: 9px;
                background: #e1e1e1;
                color: #fff;
                text-align: center;
                font-size: 12px;
                font-weight: 500;
                line-height: 15px;
            }
        }
    }
`;
const StyledPopupRedeem = styled.div`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    .box-popupconfirm {
        background: ${(p) => p.theme.colors.card};
        padding: 45px 28px 28px;
        border-radius: 8px;
        width: calc(100% - 80px);
        max-height: 90%;
        overflow: inherit;
        position: relative;
        ::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        animation: shakebox 0.3s !important;
        @keyframes shakebox {
            0% {
                top: 0px;
                left: 0px;
            }
            25% {
                top: -5px;
                left: -5px;
            }
            50% {
                top: 0;
                left: 0;
            }
            75% {
                top: 5px;
                left: 5px;
            }
            100% {
                top: 0;
                left: 0;
            }
        }
        .text-order {
            font-size: 12px;
            line-height: 15px;
            color: #525257;
            margin-bottom: 5px;
            text-align: center;
        }
        .img-popupconfirm {
            position: absolute;
            top: -100px;
            left: 50%;
            transform: translateX(-50%);
            img {
                max-width: 150px;
                width: 100%;
            }
        }
        .btn-popupconfirm {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 16px;
            .btn-redeem {
                color: #fff;
                background-color: #336c51;
                width: 100%;
                padding: 10px 0;
                font-size: 13px;
            }
            .btn-cancel {
                color: #000;
                background-color: #fff;
                border: 1px solid #e1e1e1;
                width: 100%;
                padding: 10px 0;
                font-size: 13px;
            }
        }
    }
    .title {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        justify-content: center;
        flex-direction: column;
        .text-sub-header {
            font-size: 18px;
            line-height: 21px;
            color: #000;
            font-weight: 600;
            display: block;
        }
    }
`;
const StyledUsedBtn = styled.button<{ themeColor: string }>`
    padding: 3px 12px;
    color: ${(p) => p.themeColor};
    background: ${(p) => p.theme.colors.card};
    border: 0.5px solid ${(p) => p.themeColor};
    border-radius: 40px;
    cursor: pointer;
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 16px;
    &:active {
        background: ${(p) => p.themeColor};
        color: ${(p) => p.theme.colors.color};
    }
`;
const StyledBtnConfirm = styled.button<{ themeColor: string }>`
    border-radius: 14px;
    background: ${(p) => p.themeColor};
    font-size: 13px;
    color: #fff;
    padding: 14px 32px;
    height: auto;
    width: 100%;
    border: none;
`;
